import React, { Component } from "react";
import T from "i18n-react";

class Toast extends Component {
  render() {
    let loaderClasses = this.props.err ? "failed": "done";
    let borderClass = this.props.err === true ? "border_failed": "border_success";

    return (
      <div className="cs-loader" id="bosch_loader">
        <div className={`${borderClass} cs-loader-inner`}>
          <div className={`${loaderClasses} loader`} style={{ flex: 1 }}>
            <svg viewBox="25 25 50 50">
              <circle className="loader__background" cx="50"  cy="50" r="20" strokeWidth="3" />
              <circle className="loader__rotation" cx="50" cy="50" r="20" fill="none" strokeWidth="4" />
              <path className="loader__path" d="m48,58l11,-16" strokeDasharray="23" strokeDashoffset="23" />
              <path className="loader__path" d="m48,58l-8,-6" strokeDasharray="10" strokeDashoffset="10" />
              <path className="loader__error" d="m50,58l0,-58" strokeDasharray="23" strokeDashoffset="2" />
              <circle className="loader__error" cx="50" cy="63" r="1" />
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            {T.translate(`${this.props.text}`)}
          </div>
              <button className="toast__dismiss" onClick={this.props.onDismissClick}> x </button>
               <button className="toast__close" onClick={this.props.onDismissClick}>Close</button>
        </div>
      </div>
    );
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.text == nextProps.text) {
      return false;
    }
    return true;
  }
}

export default Toast;
